import { DropdownButton, Inline } from '@omnipresentgroup/design-system';
import { type Employment, EmploymentStatus } from '@omnipresentgroup/types';
import { useState } from 'react';

import { ChangeEmploymentStatusModal } from './ChangeEmploymentStatusModal';

export const EmploymentActionsCell = ({
  employment,
  onEditClick,
}: {
  employment: Employment;
  onEditClick?: (row: Employment) => void;
}) => {
  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [newStatus, setNewStatus] = useState<EmploymentStatus | undefined>();

  return (
    <>
      <Inline gap="8" justify="flex-end">
        <DropdownButton
          key={`employment-actions-${employment.id}`}
          variant="tertiary"
          icon="Dots"
          size="small"
          options={[
            {
              name: 'Edit',
              icon: 'Edit',
              onClick: () => {
                onEditClick?.(employment);
              },
            },
            {
              name: 'Mark as onboarded',
              icon: 'Check',
              onClick: () => {
                setNewStatus(EmploymentStatus.ONBOARDED);
                setChangeStatusModalOpen(true);
              },
              disabled: employment.status !== EmploymentStatus.CREATED,
            },
            {
              name: 'Mark as active',
              icon: 'Check',
              onClick: () => {
                setNewStatus(EmploymentStatus.ACTIVE);
                setChangeStatusModalOpen(true);
              },
              disabled: employment.status !== EmploymentStatus.ONBOARDED,
            },
          ]}
        />
      </Inline>
      {changeStatusModalOpen && newStatus && (
        <ChangeEmploymentStatusModal
          key={`change-employment-status-${employment.id}`}
          modalProps={{
            open: changeStatusModalOpen,
            onOpenChange: setChangeStatusModalOpen,
          }}
          handleCancel={() => setChangeStatusModalOpen(false)}
          handleSuccess={() => setChangeStatusModalOpen(false)}
          employment={employment}
          status={newStatus}
        />
      )}
    </>
  );
};
